import { SyntheticEvent } from 'react';

export const openTab = (e: SyntheticEvent, affiliateLink: string): void => {
  e.preventDefault();
  e.stopPropagation();

  const link = document.createElement('a');
  link.setAttribute('target', '_blank');
  link.setAttribute('href', affiliateLink);
  const body = document.querySelector('body');

  if (body !== null) {
    body.append(link);
    link.click();
  }
};
